// extracted by mini-css-extract-plugin
module.exports = {"root":"IconGift_root__nvBlW"};